﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

const WeeklyLoadsBar = {
  fields: {
    barColor: { type: "text" as const },
    heightPx: { type: "text" as const },
    showGrid: {
      type: "radio" as const,
      options: [
        { label: "Show grid", value: true },
        { label: "Hide grid", value: false },
      ],
    },
    showLegend: {
      type: "radio" as const,
      options: [
        { label: "Show legend", value: true },
        { label: "Hide legend", value: false },
      ],
    },
    showValues: {
      type: "radio" as const,
      options: [
        { label: "Show values", value: true },
        { label: "Hide values", value: false },
      ],
    },
    valueDecimals: { type: "number" as const },
  },
  defaultProps: {
    barColor: "#3B82F6", // Tailwind blue-500
    heightPx: "240",
    showGrid: true,
    showLegend: false,
    showValues: true,
    valueDecimals: 0,
  },
  inline: true,
  render: (props: any) => {
    const {
      barColor = "#3B82F6",
      heightPx = "240",
      showGrid = true,
      showLegend = false,
      showValues = true,
      valueDecimals = 0,
      puck,
    } = props as any;

    const { dailyLoads, weekReport, trailingDays } = useActivitiesData();

    // Build Recharts dataset for the trailing 7 days
    const chartData = (trailingDays || []).map((d, i) => ({
      name: d.label,
      trimp: Number(dailyLoads?.[i] ?? 0),
    }));

    const h = Math.max(120, parseInt(String(heightPx || "240"), 10) || 240);

    return (
      <div ref={puck?.dragRef}>
        <div style={{ width: "100%", height: h }}>
          <ResponsiveContainer>
            <BarChart data={chartData} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
              <XAxis dataKey="name" tick={{ fill: "#FFFFFF" }} />
              <YAxis
                allowDecimals={false}
                tick={{ fill: "#FFFFFF" }}
              />
              <Tooltip formatter={(v: any) => [`${Number(v).toFixed(valueDecimals)}`, "PSS"]} />
              {showLegend ? <Legend /> : null}
              <Bar dataKey="trimp" name="Daily PSS" fill={String(barColor || "#3B82F6")}>
                {showValues ? (
                  <LabelList
                    dataKey="trimp"
                    position="top"
                    formatter={(v: any) => `${Number(v).toFixed(valueDecimals)}`}
                    fill="#FFFFFF"
                    style={{ fill: "#FFFFFF" }}
                  />
                ) : null}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>

      </div>
    );
  },
};

export default WeeklyLoadsBar;
